import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '_metronic/helpers'
import { getEmpresaById } from '../../empresas-list/core/_requests'

/**
 * Instituição da tela de valores, vinda do `:id` da rota. Em cache pela chave: o cabeçalho e o
 * que mais precisar dela compartilham a mesma requisição.
 */
export const useEmpresaAtual = () => {
  const { id } = useParams<{ id: string }>()
  const idEmpresa = Number(id)

  const { data: empresa } = useQuery(['empresa', idEmpresa], () => getEmpresaById(idEmpresa), {
    enabled: Boolean(idEmpresa),
    refetchOnWindowFocus: false,
    onError: showError,
  })

  return empresa
}
